import { useEffect } from 'react';
import { useNavigation, useRoute } from '@react-navigation/native';

/**
 * Custom hook to handle Settings navigation
 * Automatically navigates to Settings screen when route params indicate it
 */
export function useSettingsNavigation() {
  const navigation = useNavigation();
  const route = useRoute();

  useEffect(() => {
    // Check if we should navigate to Settings
    const shouldNavigateToSettings = (route.params as any)?.navigateToSettings;

    if (shouldNavigateToSettings) {
      // Navigate to Settings screen
      navigation.navigate('settings' as never);

      // Clear the navigation flag to prevent infinite loops
      navigation.setParams({ navigateToSettings: false } as never);
    }
  }, [navigation, route.params]);
}
